
import { Typography } from '@mui/material'

const HelpText = () => {

  return (
    <div className='p-5'>
      <Typography variant='h5' className='pb-5'>Invoices</Typography>
      <p>The table shows all your past invoices</p>

      <p>Click on any invoice to view / download a PDF copy.</p>
    </div>
  )
}

export default HelpText